<template>
  <div class="pb-wrap">
    <div class="card">
      <h1 class="h1">Inicio</h1>
      <p class="p">Ingresa tus datos y acepta los términos para continuar.</p>

      <div class="field">
        <label>Nombre (obligatorio)</label>
        <input type="text" v-model.trim="nombre" autocomplete="off" placeholder="Tu nombre" />
      </div>

      <div class="field">
        <label>Correo (opcional)</label>
        <input type="email" v-model.trim="correo" autocomplete="off" placeholder="correo@ejemplo.com" />
      </div>

      <div class="checkbox">
        <input id="tc" type="checkbox" v-model="acepta" />
        <label for="tc">
          Acepto los términos y condiciones.
          <span class="small">(Uso de la imagen únicamente para generar la tarjeta. Puedes pedir eliminación si aplica.)</span>
        </label>
      </div>

      <p v-if="error" class="error">{{ error }}</p>

      <div class="hr"></div>

      <div class="row">
        <button class="btn" @click="continuar">Continuar</button>
      </div>

      <p class="small" style="margin-top: 12px;">
        Flujo: Datos → Cámara → Tarjeta (50mm x 90mm)
      </p>
    </div>
  </div>
</template>

<script>
import { getSession, setSession } from '@/utils/session';

export default {
  name: 'StartView',
  data() {
    const s = getSession();
    return {
      nombre: s.nombre || '',
      correo: s.correo || '',
      acepta: Boolean(s.aceptaTerminos),
      error: '',
    };
  },
  methods: {
    continuar() {
      this.error = '';
      if (!this.nombre) {
        this.error = 'El nombre es obligatorio.';
        return;
      }
      if (!this.acepta) {
        this.error = 'Debes aceptar los términos y condiciones para continuar.';
        return;
      }

      setSession({
        nombre: this.nombre,
        correo: this.correo,
        aceptaTerminos: true,
        aceptoAt: Date.now(),
      });

      this.$router.push('/camera');
    },
  },
};
</script>
